import { render, staticRenderFns } from "./create-retur-detail-form.vue?vue&type=template&id=ba93a0a6&"
import script from "./create-retur-detail-form.vue?vue&type=script&lang=js&"
export * from "./create-retur-detail-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports